/**
 * ClerkUserProvider
 * Syncs Clerk user info with the API client
 */

import React, { createContext, useContext, useEffect, useState } from 'react';
import { useUser } from '@clerk/clerk-react';
import { setClerkUser } from '../lib/api';

const ClerkUserContext = createContext(null);

export function useClerkUserContext() {
  return useContext(ClerkUserContext);
}

export function ClerkUserProvider({ children }) {
  const { user, isLoaded, isSignedIn } = useUser();
  const [synced, setSynced] = useState(false);

  useEffect(() => {
    if (isLoaded) {
      if (isSignedIn && user) {
        // Set user info in API client
        const userInfo = {
          id: user.id,
          email: user.primaryEmailAddress?.emailAddress,
          firstName: user.firstName,
          lastName: user.lastName,
          fullName: user.fullName,
          imageUrl: user.imageUrl,
        };
        
        console.log('[ClerkUserProvider] User synced:', {
          id: userInfo.id,
          email: userInfo.email
        });
        
        setClerkUser(userInfo);
        setSynced(true);
      } else {
        // Clear user info
        setClerkUser(null);
        setSynced(false);
      }
    }
  }, [isLoaded, isSignedIn, user]);

  const contextValue = {
    user: isSignedIn ? {
      id: user?.id,
      email: user?.primaryEmailAddress?.emailAddress,
      firstName: user?.firstName,
      lastName: user?.lastName,
      fullName: user?.fullName,
      imageUrl: user?.imageUrl,
    } : null,
    isLoaded,
    isSignedIn,
    synced,
  };

  return (
    <ClerkUserContext.Provider value={contextValue}>
      {children}
    </ClerkUserContext.Provider>
  );
}

export default ClerkUserProvider;

